import { AccountContext } from "views/AccountWrapper";
import useTypedContext from "hooks/useTypedContext";

import PersonalSettingsGroupsPageLayout from "./PageLayout";
import PersonalSettingsSpacesSortHeader from "./SortHeader";
import PersonalSettingsGroupsList from "./List";
import PersonalSettingsGroupsEmpty from "./Empty";

const PersonalSettingsGroups = () => {
  const { viewer } = useTypedContext(AccountContext);

  return (
    <PersonalSettingsGroupsPageLayout>
      {viewer.teams.length === 0 && <PersonalSettingsGroupsEmpty />}
      {viewer.teams.length > 0 && (
        <>
          <PersonalSettingsSpacesSortHeader />
          <PersonalSettingsGroupsList groups={viewer.teams} />
        </>
      )}
    </PersonalSettingsGroupsPageLayout>
  );
};

export default PersonalSettingsGroups;
